import * as React from 'react';

import Dialog from '@mui/material/Dialog';
//import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';

import DialogTitle from '@mui/material/DialogTitle';
import StatusContext from '../../../contexts/StatusContext'
import AITestContext from "../../../contexts/AITestContext.js";

import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { ProgressIcon } from '../customicons/ProgressIcon';
import {MyButton1} from "../mybutton1/MyButton1"

export const  BuyTestDialog = () => {
  
    const {
        changeLanguage,
        isLoading,
        setIsLoading,
        showbuytestdialog,
        setShowBuyTestDialog,
        dialogStatus,
        setDialogStatus,
        isMe,
    } = React.useContext(StatusContext);
 
  const {
    buyprice,
    buytestname,
    buytestcreatorid,
    creatorname,
    startBuyTestCheckoutSession,

} = React.useContext(AITestContext);

const styles = {
  container: {
    alignItems: 'center', // Center vertically
 
    padding: '10px',
    marginBottom: '10px',
    width: '100%',
    border:'none',
 
    backgroundColor: 'rgb(240, 231, 212)', 
    transition: 'background-color 0.3s ease', // Optional transition for smooth effect
    },

    item: {
      
      alignItems: 'center', // Center vertically
      textAlign: 'center',
      color: 'maroon',
      borderRadius: '5px',
     
      padding: '3px',
      marginBottom: '10px',
      width: '100%',
      border:'none',
   
      backgroundColor: 'rgb(240, 231, 212)',
      transition: 'background-color 0.3s ease', // Optional transition for smooth effect
      },
  title: {
    display: 'flex',
    color: 'rgb(138, 57, 57)',
    fontSize: '26px',
    marginTop:'-25px',
    marginBottom: '-15px',
    justifyContent: 'center',
  },
  
  text: {
  
    color: 'rgb(138, 57, 57)',
    fontSize: '16px',
    fontWeight: '500',
    marginBottom:'15px',
    justifyContent: 'center',
    textAlign:'center',
  },
  savebutton: {
   
    justifyContent: 'center',
  },
  note: {
    color: 'rgb(138, 57, 57)',
    fontSize: '12px',
    fontWeight: '500',
    marginBottom:'15px',
    justifyContent: 'center',
    textAlign:'center',
  }
 
}


    const handleBuyTest = async () => {
      console.log("handleBuyTest:")
     
      sessionStorage.setItem('buytestname', buytestname)
      let test = {
        type:'MyTestPurchase',
        name : buytestname,
        creatorid: buytestcreatorid,
        creator: creatorname,
        price: buyprice,

      }

      sessionStorage.setItem('PurchaseType', JSON.stringify(test))
 
      if (!isMe())
      {
        setIsLoading(true)
        let result = await startBuyTestCheckoutSession()
        if (!result)
        {
          //setDialogStatus("This test cannot be purchased.")
          setDialogStatus(changeLanguage('aitest', "cannotbepurchased"))
          setIsLoading(false)
          return
        }
      }
      else {
        //This is my test and cannot be purchased
         setDialogStatus(changeLanguage('aitest', "mytestalert"))
          setIsLoading(false)
          return
      }
   
      setIsLoading(false)
      handleClose()
    }


  const handleClose = () => {
  
    setShowBuyTestDialog(false);
  };

  return (
    <React.Fragment>
      
      <Dialog
        open={showbuytestdialog}
        onClose={handleClose}
        PaperProps={{
          component: 'form',
          onSubmit: (event) => {
            event.preventDefault();
            const formData = new FormData(event.currentTarget);
            const formJson = Object.fromEntries(formData.entries());
            const email = formJson.email;
            console.log(email);
            handleClose();
          },
        }}
      >
        <DialogTitle></DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>

         <DialogContent>
            
              <div style={{marginBottom: '-40px'}}>
                
              <h2 className="payasyougoTitle"  >{changeLanguage('aitest', 'buytesttitle')}</h2>
              <br></br>
              <div className="getcreditsText">
                {changeLanguage('aitest', 'selectedtestinfo')}
             
                <br></br>
                <br></br>
              </div>
        
                 
            </div>
            <br></br>
        
           
            <div    style={{ ...styles.item, backgroundColor:'rgb(240, 231, 212)' }}>
             <br></br>
              <h4 style={{ color: 'rgb(138, 57, 57)', padding:'25px', paddingTop:'10px', paddingBottom:'0px'}}>{buytestname}</h4>
              <h6 style={{ color: 'rgb(138, 57, 57)'}}>{changeLanguage('aitest', 'by')} {creatorname}</h6>

              <h6 style={{ color: 'rgb(138, 57, 57)', paddingTop:'15px'}}>{changeLanguage('aitest', 'testprice')} {buyprice}</h6>
              <br></br>
          
            
              <MyButton1 text={changeLanguage('aitest', 'buytesttitle')} stylename="buyCreditsButton" onClick = {() => {handleBuyTest(buyprice)}}/> 
                <br></br>
            </div>
          <br></br>
          {
            (dialogStatus) &&
            <label>{dialogStatus}</label>
          }
        </DialogContent>

        {/*
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button type="submit">Subscribe</Button>
          <PushButton label="Login"/>
        </DialogActions>
        */}
       
      </Dialog>

     <ProgressIcon isLoading={isLoading} /> 

    </React.Fragment>
    
  );
}